import i18next from 'i18next';

function applyI18nAttributes(element: HTMLElement): void {
  const key = element.getAttribute('data-i18n');
  if (key && element.childElementCount === 0) {
    element.textContent = i18next.t(key);
  }

  const placeholderKey = element.getAttribute('data-i18n-placeholder');
  if (
    placeholderKey &&
    (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)
  ) {
    element.placeholder = i18next.t(placeholderKey);
  }

  const ariaKey = element.getAttribute('data-i18n-aria-label');
  if (ariaKey) {
    element.setAttribute('aria-label', i18next.t(ariaKey));
  }

  const titleKey = element.getAttribute('data-i18n-title');
  if (titleKey) {
    element.title = i18next.t(titleKey);
  }
}

export function applyI18n(root: ParentNode = document): void {
  if (root instanceof HTMLElement) {
    applyI18nAttributes(root);
  }

  root.querySelectorAll<HTMLElement>('[data-i18n]').forEach((element) => {
    const key = element.getAttribute('data-i18n');
    if (key && element.childElementCount === 0) {
      element.textContent = i18next.t(key);
    }
  });

  root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('[data-i18n-placeholder]').forEach(
    (element) => {
      const key = element.getAttribute('data-i18n-placeholder');
      if (key) {
        element.placeholder = i18next.t(key);
      }
    },
  );

  root.querySelectorAll<HTMLElement>('[data-i18n-aria-label]').forEach((element) => {
    const key = element.getAttribute('data-i18n-aria-label');
    if (key) {
      element.setAttribute('aria-label', i18next.t(key));
    }
  });

  root.querySelectorAll<HTMLElement>('[data-i18n-title]').forEach((element) => {
    const key = element.getAttribute('data-i18n-title');
    if (key) {
      element.title = i18next.t(key);
    }
  });
}
